import * as i18next from 'i18next';
import { G2S } from 'core/g2s';

export interface SupportCategoryOption {
    label: string;
    value: string | null;
}

class SupportClass {
    public refundOptions (): SupportCategoryOption[] {
        let refundOptions: SupportCategoryOption[] = [
            {
                label: '',
                value: null
            },
            {
                label:  i18next.t('label_support_sub_category_personal'),
                value: 'clarification_personal_reasons',
            },
            {
                label:  i18next.t('label_support_sub_category_light_rescheldue'),
                value: 'clarification_flight_rescheldue',
            },
            {
                label:  i18next.t('label_support_sub_category_flight_cancellation'),
                value: 'clarification_flight_cancellation',
            },
            {
                label:  i18next.t('label_support_sub_category_passenger_sickness'),
                value: 'clarification_passenger_sickness',
            },
            {
                label:  i18next.t('label_support_sub_category_entry_ban'),
                value: 'clarification_entry_ban',
            },
            {
                label:  i18next.t('label_support_sub_category_refusal_visa'),
                value: 'clarification_refusal_visa',
            },
            {
                label: i18next.t('label_support_sub_category_death_or_sickness'),
                value: 'clarification_death_or_sickness',
            },
        ]
        return refundOptions;  
    }

    public changeTicketOptions(): SupportCategoryOption[] {
        const changeOptions: SupportCategoryOption[] = [
            {
                label: '',
                value: null,
            },
            {
                label:  i18next.t('label_support_sub_category_personal'),
                value: 'clarification_personal_reasons',
            },
            {
                label:  i18next.t('label_support_sub_category_light_rescheldue'),
                value: 'clarification_flight_rescheldue',
            },
            {
                label:  i18next.t('label_support_sub_category_flight_cancellation'),
                value: 'clarification_flight_cancellation',
            },
        ]
        return changeOptions;
    }

    public changeInfoOptions(): SupportCategoryOption[] {
        const defaultCategory: SupportCategoryOption[] = [
            {
                label: '',
                value: null,
            },
            {
                label:  i18next.t('label_support_sub_category_birthday'),
                value: 'clarification_birthday',
            },
            {
                label:  i18next.t('label_support_sub_category_passport_details'),
                value: 'clarification_info_details',
            },
            {
                label:  i18next.t('label_support_sub_category_full_name'),
                value: 'clarification_info_name',
            },
        ]
        return defaultCategory;
    }

    public additionalServiceOptions (): SupportCategoryOption[] {
        const additionalServiceOptions: SupportCategoryOption[] = [
            {
                label: '',
                value: null,
            },
            {
                label: i18next.t('label_support_sub_category_cancel_service'),
                value: 'clarification_service_cancel',
            },
            {
                label: i18next.t('label_support_sub_category_add_service'),
                value: 'clarification_service_add',
            },
        ]
        return additionalServiceOptions;
    }

    public baggageOptions(): SupportCategoryOption[] {
        const defaultCategory: SupportCategoryOption[] = [
            {
                label: '',
                value: null
            }, 
            {
                label:  i18next.t('label_support_sub_category_baggage_buy_additional'),
                value: 'baggage_buy_additional',
            },
            {
                label:  i18next.t('label_support_sub_category_baggage_clarify_weight'),
                value: 'baggage_clarify_weight',
            },
            {
                label:  i18next.t('label_support_sub_category_baggage_error'),
                value: 'baggage_error',
            },
            {
                label:  i18next.t('label_support_sub_category_baggage_non_standard'),
                value: 'baggage_non_standard',
            },
            {
                label: i18next.t('label_support_category_other'),
                value: 'another'
            },
        ]
        return defaultCategory;
    }
    
    public categoryOptions(): SupportCategoryOption[] {
        const defaultCategory: SupportCategoryOption[] = [
            {
                label: '',
                value: null
            },
            {
                label: i18next.t('label_support_category_itinerary'),
                value: 'itinerary'
            },
            {
                label: i18next.t('label_support_category_flight_refund'),
                value: 'flight_refund'
            },
            {
                label: i18next.t('label_support_category_flight_change'),
                value: 'flight_change'
            },
            {
                label: i18next.t('label_support_category_cancel_same_day'),
                value: 'cancel_same_day'
            },
            {
                label: i18next.t('label_support_category_changes'),
                value: 'changes'
            },
            {
                label: i18next.t('label_support_category_baggage'),
                value: 'baggage'
            },
            {
                label: i18next.t('label_support_category_kid_ticket'),
                value: 'kid_ticket'
            },
            {
                label: i18next.t('label_support_category_pet_ticket'),
                value: 'pet_ticket'
            },
            {
                label: i18next.t('label_support_category_add_services'),
                value: 'add_services'
            },
            {
                label: i18next.t('label_support_category_error'),
                value: 'error'
            },
            
            {
                label: i18next.t('label_support_category_timetable'),
                value: 'timetable'
            },
            {
                label: i18next.t('label_support_category_bonuses'),
                value: 'bonuses'
            },
            {
                label: i18next.t('label_support_category_other'),
                value: 'other'
            }
        ];
        // if (G2S.config.theme !== 'aviasales') {
        //     defaultCategory = [
        //         ...defaultCategory,
        //         {
        //             label: i18next.t('label_support_category_bonuses'),
        //             value: 'bonuses'
        //         },
        //         // {
        //         //     label: i18next.t('label_support_category_corporate'),
        //         //     value: 'corporate'
        //         // }
        //     ];
        // }

        return defaultCategory;
    }
}

export const Support = new SupportClass();